import { enGBTranslations } from './en-GB-settings';
import { enUSTranslations } from './en-US-settings';
import { esUSTranslations } from './es-US-settings';
import { fiFITranslations } from './fi-FI-settings';
import { frBETranslations } from './fr-BE-settings';
import { arAETranslations } from './ar-AE-settings';
import { nbNOTranslations } from './nb-NO-settings';
import { nlBETranslations } from './nl-BE-settings';
import { svSETranslations } from './sv-SE-settings';
import { ptBRTranslations } from './pt-BR-settings';
import { itITTranslations } from './it-IT-settings';

export function getOptions() {
  return {
    fallbackLng: 'en-GB',
    lng: 'en-GB',
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
    resources: {
      'ar-AE': arAETranslations,
      'en-GB': enGBTranslations,
      'en-US': enUSTranslations,
      'es-US': esUSTranslations,
      'fi-FI': fiFITranslations,
      'fr-BE': frBETranslations,
      'nb-NO': nbNOTranslations,
      'nl-BE': nlBETranslations,
      'sv-SE': svSETranslations,
      'pt-BR': ptBRTranslations,
      'it-IT': itITTranslations,
    },
    react: {
      nsMode: 'fallback',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'a'],
    },
  };
}
